import { render, staticRenderFns } from "./StepDots.vue?vue&type=template&id=7c09247b&scoped=true"
import script from "./StepDots.vue?vue&type=script&lang=js"
export * from "./StepDots.vue?vue&type=script&lang=js"
import style0 from "./StepDots.vue?vue&type=style&index=0&id=7c09247b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c09247b",
  null
  
)

export default component.exports